import React from 'react';

export default function TechnoSwordSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="21.79,28.09 18.21,28.09 18.21,2.0 21.79,2.0" fill="#7F7D61" />
      <polygon points="21.46,20.87 19.37,18.78 21.46,16.68 23.55,18.78" fill="#7F7D61" />
      <polygon points="19.37,18.78 21.46,20.87 20.85,20.57 18.76,18.47" fill="#454434" opacity="0.95" />
      <polygon points="20.85,20.57 21.46,20.87 23.55,18.78 22.94,18.47" fill="#454434" opacity="0.95" />
      <polygon points="23.3,27.51 20.71,26.44 21.31,25.0 23.9,26.07" fill="#7F7D61" />
      <polygon points="23.93,28.96 16.45,28.96 16.45,27.4 23.93,27.4" fill="#7F7D61" />
      <polygon points="16.45,28.96 23.93,28.96 23.55,28.78 16.07,28.78" fill="#454434" opacity="0.95" />
      <polygon points="16.45,28.96 16.07,28.78 16.07,27.22 16.45,27.4" fill="#454434" opacity="0.95" />
      <polygon points="20.81,35.97 19.56,35.97 19.56,28.96 20.81,28.96" fill="#7F7D61" />
      <polygon points="19.56,35.97 19.19,35.78 19.19,28.78 19.56,28.96" fill="#454434" opacity="0.95" />
      <polygon points="22.6,33.75 20.01,34.83 19.41,33.39 22.0,32.32" fill="#7F7D61" />
      <polygon points="20.01,34.83 22.6,33.75 22.32,33.61 19.73,34.69" fill="#454434" opacity="0.95" />
      <polygon points="21.52,38.0 19.18,38.0 19.18,36.05 21.52,36.05" fill="#7F7D61" />
      <polygon points="19.18,38.0 21.52,38.0 20.82,37.65 18.48,37.65" fill="#454434" opacity="0.95" />
      <polygon points="19.18,38.0 18.48,37.65 18.48,35.7 19.18,36.05" fill="#454434" opacity="0.95" />
    </svg>
  );
}
